module.exports = __webpack_public_path__ + "static/media/arrowUpside.11a024f7.svg";